import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import qs from 'qs'
import store from './store/index.js'
import util from './assets/js/util.js'
import {client} from './assets/js/client.js'
import ElementUI from 'element-ui';
import '@/assets/css/layout.min.css';
import 'element-ui/lib/theme-chalk/index.css';
import 'quill/dist/quill.snow.css'
import Print from 'vue-print-nb'; // 打印
Vue.use(Print); // 打印

Vue.config.productionTip = false
Vue.use(ElementUI);

Vue.prototype.axios = axios;
Vue.prototype.qs = qs;
Vue.prototype.$client = client;
Vue.prototype.$util = util;

// 引入自定义组件。index.js是组件的默认入口
import {myTextEllipsis,myEditor} from '@/components/index.js'
Vue.use(myTextEllipsis);
Vue.use(myEditor);


/* 响应拦截器 */
router.beforeEach((to, from, next) => {
document.title = to.meta.title;
if(to.path == '/login'){
	localStorage.removeItem('token');
	next();
}else{
	//next();
	// var arr = JSON.parse(localStorage.getItem('menu_auth_list'));
	// if(arr && arr.indexOf(to.path) == -1){
	// 	next('/error');
	// }else {
		var token = localStorage.getItem('token');
		if(token){
			
			next();
		}else{
			next('/login');
		}
	// }
}
});

new Vue({
  router,
	store,
  render: h => h(App),
}).$mount('#app')
